import React, { FC, useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Row, Col, Collapse, Spin } from "antd";
import { DateTimeUtils, CommonUtils, Message } from "../../../../../../utils";
import AntTable from "../../../../../../components/Table/AntTable";
import ViewAction from "../../../../../../components/Actions/ViewAction";
import ListItemAction from "../../../../../../components/Actions/ListItemAction";
import { useTranslation } from "react-i18next";
import { useLang } from "../../../../../../hooks/useLang";
import Item from 'antd/lib/list/Item';
import { CONSTANT_CONFIG } from "../../../../../../constants";
import { OpacSearchUnionCatalogueApi } from "../../../../../../api";
import {
    FilterOutlined,
    RightOutlined, CaretRightOutlined, DoubleRightOutlined, TableOutlined
} from '@ant-design/icons';
import { useErrorHandler } from "../../../../../../hooks/useErrorHandler";

const { Panel } = Collapse;

const UnionJournalSearchListListing: FC<any> = props => {
    const { t } = useTranslation();
    const { loading, listData, selectedRowKeys, onChangeSwitchToggle,
        handleOnChanged, handleTableChange, handleCallbackFunc, libraryproduct,
        libraryreservericon, libraryebookicon, bookCoverNotAvailable, handleShowForm,
        setEntity, handleShowReserveForm, documentType,
        journalCatalougeData, setJournalCatalougeData,
        libraryCatalougeData, setLibraryCatalougeData,
        activePanel, setActivePanel
    } = props;
    const { lang, getUserLangUrl, getLangUrl } = useLang();
    const { handleErrorMessage, handleSuccessMessage, showErrorMessage } = useErrorHandler();
    const [detailsLoading, setDetailsLoading] = useState(false);

    const onChangePanel = (key: string | string[]) => {
        const lastActivePanel = Array.isArray(key) ? key[key.length - 1] : key;
        // setLastActivePanel(lastActivePanel); // Save the current active panel as the last active panel
        setActivePanel(lastActivePanel);

        console.log(listData[lastActivePanel]);

        if ((documentType == 'library' || documentType == 'city')) {
            onClickPanelLoadJournalByLibraryCatalogueId(listData[lastActivePanel]?.id);
        }

        if ((documentType == 'journal' || documentType == 'alldocuments')) {
            onClickPanelLoadLibraryByJournalCatalogueId(listData[lastActivePanel]?.id);
        }

    };

    const onClickPanelLoadJournalByLibraryCatalogueId = (libraryCatalogueId) => {
        if (libraryCatalogueId) {

            setDetailsLoading(true);

            const payload = {
                library_catalouge_id: libraryCatalogueId
            }
            OpacSearchUnionCatalogueApi.getJournalByLibraryCatalogueId(payload)
                .then(res => {
                    if (res.data?.data?.results?.length > 0) {
                        console.log(res.data.data.results);
                        setJournalCatalougeData(res.data.data.results);
                    }
                    setDetailsLoading(false);

                }).catch(err => {
                    setDetailsLoading(false);
                    handleErrorMessage(err);
                });
        }

    }

    const onClickPanelLoadLibraryByJournalCatalogueId = (journalCatalogueId) => {
        if (journalCatalogueId) {

            setDetailsLoading(true);

            const payload = {
                journal_catalouge_id: journalCatalogueId
            }
            OpacSearchUnionCatalogueApi.getLibraryByJournalCatalogueId(payload)
                .then(res => {
                    if (res.data?.data?.results?.length > 0) {
                        console.log(res.data.data.results);
                        setLibraryCatalougeData(res.data.data.results);
                    }
                    setDetailsLoading(false);

                }).catch(err => {
                    setDetailsLoading(false);
                    handleErrorMessage(err);
                });
        }

    }

    return (
        <>
            {loading && <div className="text-center"><Spin className='d-inline-block' size='large' /></div>}

            {(listData.length > 0) ? (
                <>
                    <div className='container-fluid'>

                        <div className='library-collapse pb-5 mb-5'>
                            {/* <Collapse defaultActiveKey={['0']} onChange={onChangePanel}> */}
                            <Collapse defaultActiveKey={['0']} onChange={onChangePanel} activeKey={activePanel}>

                                {(documentType == 'journal' || documentType == 'alldocuments') && listData &&
                                    listData.map((dataInfo, indexkey) => (

                                        <Panel header={lang == 'bn' ? (dataInfo ? dataInfo.journal_catalouge_name_bn : null) : (dataInfo ? dataInfo.journal_catalouge_name_en : null)} key={indexkey} >
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={18}>
                                                    <p className='fw-normal'>
                                                        {lang == 'bn' ? (dataInfo ? dataInfo.journal_catalouge_name_bn : null) : (dataInfo ? dataInfo.journal_catalouge_name_en : null)}
                                                        {dataInfo ? ', ISSN: ' + dataInfo.journal_catalouge_issn : null}
                                                        {dataInfo ? ', Frequency: ' + dataInfo.journal_catalouge_frequancy : null}
                                                    </p>
                                                </Col>
                                                <Col xs={24} md={6} className='text-end'>
                                                    {/* <div className='library-collapse-titleright'>This  library holds 12 journal.</div> */}
                                                </Col>
                                            </Row>

                                            {detailsLoading && <div className="text-center"><Spin className='d-inline-block' size='large' /></div>}
                                            {libraryCatalougeData?.length > 0 && !detailsLoading &&
                                                <div className='library-collapse-table'>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th className='fw-bold text-left h5'><TableOutlined />{t('Library')}</th>
                                                                <th className='fw-bold text-left h5'><TableOutlined />{t('Journals')}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {libraryCatalougeData && libraryCatalougeData.map(libraryInfo => (
                                                                <tr>
                                                                    <td className='fw-normal'> {libraryInfo.name_en} - {libraryInfo.short_name} <br /> {libraryInfo.address}  </td>
                                                                    <td>
                                                                        {libraryInfo.journalHolding && libraryInfo.journalHolding.map(journalHoldingInfo => (
                                                                            <>
                                                                                <span style={{ backgroundColor: '#e6f7ff', marginLeft: '5px' }}>
                                                                                    {journalHoldingInfo.volume}({journalHoldingInfo.issue_no})&nbsp;{journalHoldingInfo.year}
                                                                                </span>
                                                                                ;&nbsp;
                                                                            </>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            }
                                        </Panel>

                                    ))}


                                {(documentType == 'library' || documentType == 'city') && listData &&
                                    listData.map((dataInfo, indexkey) => (

                                        <Panel header={lang == 'bn' ? (dataInfo ? dataInfo.name_bn : null) : (dataInfo ? dataInfo.name_en : null)} key={indexkey} >
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={18}>
                                                    <p className='fw-normal'>
                                                        {lang == 'bn' ? (dataInfo ? dataInfo.name_bn : null) : (dataInfo ? dataInfo.name_en : null)}; &nbsp;
                                                        {dataInfo ? dataInfo.address : ''}
                                                        {/* {dataInfo ? ', code: ' + dataInfo.short_name : null}
                                                        {dataInfo ? ', city: ' + dataInfo.city : null}
                                                        {dataInfo ? ', email: ' + dataInfo.email : null} */}
                                                    </p>
                                                </Col>

                                                {/* { onClick={(dataInfo) => onClickPanelLoadJournalByLibraryCatalogueId(dataInfo?.id)}} */}

                                                <Col xs={24} md={6} className='text-end'>
                                                    <div className='library-collapse-titleright'>This  library holds {journalCatalougeData?.length} journal.</div>
                                                </Col>
                                            </Row>

                                            {detailsLoading && <div className="text-center"><Spin className='d-inline-block' size='large' /></div>}

                                            {journalCatalougeData?.length > 0 && !detailsLoading &&
                                                <div className='library-collapse-table'>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th className='fw-bold text-left h5'><TableOutlined />{t('Journal Name')}</th>
                                                                <th className='fw-bold text-left h5'><TableOutlined />{t('Journals Information')}</th>
                                                            </tr>

                                                        </thead>
                                                        <tbody>
                                                            {journalCatalougeData && journalCatalougeData.map(journalInfo => (
                                                                <tr>
                                                                    <td className='fw-normal'>
                                                                        <p className='p-0 m-0'>{lang == 'bn' ? (journalInfo ? journalInfo.name_bn : null) : (journalInfo ? journalInfo.name_en : null)}</p>
                                                                    </td>
                                                                    <td className='fw-normal'>
                                                                        {journalInfo.journalHolding && journalInfo.journalHolding.map(journalHoldingInfo => (
                                                                            <>
                                                                                <span style={{ backgroundColor: '#e6f7ff', marginLeft: '5px' }}>
                                                                                    {journalHoldingInfo.volume}({journalHoldingInfo.issue_no})&nbsp;{journalHoldingInfo.year}
                                                                                </span>
                                                                                ;&nbsp;
                                                                            </>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            ))}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            }

                                        </Panel>

                                    ))}

                            </Collapse>
                        </div>
                    </div>
                </>
            ) :
                (
                    <div className='text-center' style={{ paddingBottom: "50px", color: "red" }}>Sorry! No search items were found.</div>
                )

            }

        </>
    );
}

export default React.memo(UnionJournalSearchListListing);
